<template>
    <div class="box">
    	<div class="logo">
    		<img src="../assets/images/bg1.png" alt="">
    	</div>
    	<div class="title_box">
    		“天赋河套”3Q(全要素、全链条、全产业)产业数字化大数据应用平台
    	</div>
    	<div class="content">
    		<div class="content_box content_l">
    			<a href="http://sy.tfhtsy.com/bynesuyuan/suyuan/login">
    				<img src="../assets/images/bg4.png" alt="">
    				<div class="content_rk">
    					追溯入口
    				</div>
    			</a>

    		</div>
    		<div class="content_box content_r">
    			<a href="http://dsj.tfhtsy.com/byne_dataplatform/platform/login">
    				<img src="../assets/images/bg3.png" alt="">
    				<div class="content_rk2">
    					大数据入口
    				</div>
    			</a>

    		</div>
    	</div>
    	<div class="bottom">
    		<img src="../assets/images/bg2.png" alt="">
    	</div>
    </div>
</template>

<script>

    export default {
        components: {  },
        data() {
            return {


            }
        },
        async created() {

        },
        mounted() {},
        methods:{

        },


    }
</script>

<style lang="scss" scoped>
    .box{
    	width: 100%;
    	height: 100%;
    	min-width: 1400px;
    	background: url("../assets/images/bg.png") no-repeat;
    	background-size: 100% 100%;
    	position: relative;
    }
    .logo{
    	width: 180px;
      height: 80px;
      opacity: 1;
      margin-bottom: 4%;
    }
    .logo img{
      width: 100%;
      height: 100%;
      margin: 50px 0 0 150px;
    }
    .title_box{
    	width: 100%;
    	height: 10%;
    	text-align: center;
    	font-size: 40px;
    	font-family: MicrosoftYaHei;
    	color: #FFFFFF;
    	font-weight: 700;
    }
    .content{
    	width: 65%;
    	height: 55%;
    	display: flex;
    	margin: auto;
    }
    .content_box{
    	width: 50%;
    	height: 100%;
    	position: relative;

    }
    .content_box img{
    	width: 50%;
    	height: 70%;
    	width: 41%;
    	height: 60%;
    	position: absolute;
    	top: 0;
    	left: 0;
    	right: 0;
    	bottom: 0;
    	margin: auto;
    	cursor: pointer;
    }
    .content_rk{
    	font-size: 25px;
    	font-weight: bold;
    	color: #FFFFFF;
    	position: absolute;
    	bottom: 34%;
    	left: 42.3%;

    }
    .content_rk2{
    	font-size: 25px;
    	font-weight: bold;
    	color: #FFFFFF;
    	position: absolute;
    	bottom: 34%;
    	left: 40%;

    }



    .bottom{
    	width: 100%;
    	height: 28%;
    	position: absolute;
    	bottom: 5px;
    }
    .bottom img{
    	width: 100%;
    	height: 100%;
    }

    @media screen and (min-width:1920px) and (min-height:1080px){
    	.bottom{
    		height: 26%;
    	}
    }
    @media screen and (min-width:2560px) and (min-height:1440px){
    	.bottom{
    		height: 26%;
    	}
    }
</style>



// WEBPACK FOOTER //
// src/page/index.vue